import LocalFiles from "src/modules/local-files";

const avatarFiles = new LocalFiles({
  directoryName: "avatar-images"
});

export default avatarFiles;
